module.exports = __webpack_public_path__ + "fed2f412b62dfef61e0b090a50565918.png";